<template>
	<v-row v-if="!loading" class="ma-0 pb-offset">
		<v-col class="pa-0">

			<show v-if="models.complianceobjective" :id="id" :models="models" :infos="infos" topClass=""></show>

			<!-- Avanzamento indicatore -->
			<v-card v-if="objective" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Avanzamento</p>
					<v-spacer></v-spacer>
					<v-btn text color="primary" small @click="openMeasure"><v-icon left small>mdi-gauge</v-icon> Aggiorna misura</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<v-row dense class="mb-2">
						<v-col cols="4"><div class="grey--text">Partenza</div><div class="text-h6">{{ fmt(objective.baseline_value) }}</div></v-col>
						<v-col cols="4"><div class="grey--text">Attuale</div><div class="text-h6">{{ fmt(objective.current_value) }} <span class="caption grey--text">{{ objective.unit }}</span></div></v-col>
						<v-col cols="4"><div class="grey--text">Target</div><div class="text-h6">{{ fmt(objective.target_value) }}</div></v-col>
					</v-row>
					<template v-if="objective.progress_pct != null">
						<v-progress-linear :value="objective.progress_pct" height="22" rounded :color="progressColor(objective.progress_pct)">
							<strong class="white--text">{{ objective.progress_pct }}%</strong>
						</v-progress-linear>
						<div v-if="objective.measured_at" class="caption grey--text mt-2">Ultima misurazione: {{ objective.measured_at }}</div>
					</template>
					<div v-else class="grey--text">Imposta target e valore attuale per calcolare l'avanzamento.</div>
				</v-card-text>
			</v-card>

			<!-- Norme -->
			<v-card v-if="objective" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Norme</p>
					<v-spacer></v-spacer>
					<v-btn text color="primary" small @click="openNorms"><v-icon left small>mdi-pencil</v-icon> Modifica</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<template v-if="objective.norms && objective.norms.length">
						<v-chip v-for="n in objective.norms" :key="n.value" :color="n.color || 'primary'" dark small class="mr-1" label>{{ n.text }}</v-chip>
					</template>
					<span v-else class="grey--text">— nessuna —</span>
				</v-card-text>
			</v-card>

			<dms-uploader class="mt-4" :id="id" attachable-type="complianceobjective"></dms-uploader>

			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-fab-transition>
						<v-btn v-on="{ ...tooltip }" @click.native="$eventBusUtility.goTo($router, 'complianceobjectives-edit', id)" color="primary" dark fixed bottom right fab>
							<v-icon>edit</v-icon>
						</v-btn>
					</v-fab-transition>
				</template>
				<span>Modifica</span>
			</v-tooltip>

			<v-dialog v-model="measureDialog" max-width="480" persistent>
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Aggiorna misurazione</p></v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-text-field v-model="measureForm.current_value" label="Valore attuale" type="number" outlined dense :suffix="objective && objective.unit" prepend-icon="mdi-gauge"></v-text-field>
						<gmh-date-picker v-model="measureForm.measured_at" label="Data misurazione" prepend-icon="mdi-calendar" editable></gmh-date-picker>
						<v-select v-model="measureForm.status" :items="statusOptions" item-text="text" item-value="value" label="Stato" outlined dense :menu-props="{'offset-y': true}" prepend-icon="mdi-flag"></v-select>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-3">
						<v-spacer></v-spacer>
						<v-btn text color="info" @click="measureDialog = false">Annulla</v-btn>
						<v-btn text color="primary" :loading="saving" @click="saveMeasure">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="normsDialog" max-width="560" persistent>
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Norme applicabili</p></v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-autocomplete v-model="formNorms" :items="normOptions" item-text="text" item-value="value"
							label="Norme" outlined dense :menu-props="{'offset-y': true}" multiple chips small-chips deletable-chips prepend-icon="mdi-certificate"></v-autocomplete>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-3">
						<v-spacer></v-spacer>
						<v-btn text color="info" @click="normsDialog = false">Annulla</v-btn>
						<v-btn text color="primary" :loading="savingNorms" @click="saveNorms">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'ComplianceObjective',
	props: { id: Number },
	data() {
		return {
			loading: true,
			models: {},
			infos: {},
			measureDialog: false,
			saving: false,
			measureForm: { current_value: null, measured_at: null, status: null },
			normsDialog: false,
			savingNorms: false,
			formNorms: [],
			normOptions: [],
			statusOptions: [
				{ value: 'attivo', text: 'Attivo' },
				{ value: 'raggiunto', text: 'Raggiunto' },
				{ value: 'non_raggiunto', text: 'Non raggiunto' },
				{ value: 'sospeso', text: 'Sospeso' }
			]
		}
	},
	computed: {
		objective() { return this.models.complianceobjective }
	},
	created() { this.load() },
	methods: {
		load() {
			this.loading = true
			this.axios.get('complianceobjectives/' + this.id).then(r => {
				this.models = r.data.models
				this.infos = r.data.infos
				this.loading = false
			}, () => { this.loading = false; this.$store.commit('setSnackbarError') })
		},
		fmt(v) { return v != null && v !== '' ? Number(v).toLocaleString('it-IT') : '–' },
		progressColor(p) { return p >= 100 ? 'success' : p >= 60 ? 'light-green' : p >= 30 ? 'orange' : 'red' },
		openMeasure() {
			this.measureForm = { current_value: this.objective.current_value, measured_at: this.objective.measured_at || new Date().toISOString().slice(0, 10), status: this.objective.status }
			this.measureDialog = true
		},
		saveMeasure() {
			this.saving = true
			this.axios.put('complianceobjectives/' + this.id + '/measure', this.measureForm).then(() => {
				this.saving = false; this.measureDialog = false
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Misurazione aggiornata', timeout: 4000 })
				this.load()
			}, () => { this.saving = false; this.$store.commit('setSnackbarError') })
		},
		openNorms() {
			this.formNorms = (this.objective.norms || []).map(n => n.value)
			if (!this.normOptions.length) this.axios.get('compliance-norms-options').then(r => { this.normOptions = r.data.data })
			this.normsDialog = true
		},
		saveNorms() {
			this.savingNorms = true
			this.axios.put('complianceobjectives/' + this.id, { norms: this.formNorms }).then(() => {
				this.savingNorms = false; this.normsDialog = false
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Salvato', timeout: 4000 })
				this.load()
			}, () => { this.savingNorms = false; this.$store.commit('setSnackbarError') })
		}
	}
}
</script>
